export default "__VITE_ASSET__4qAA2JZJ__"